import styled from 'styled-components';

import grid from '~/styles/grid';

interface GridProps {
  numberOfColumns: number;
}

const calculateColumns = (numberOfColumns: number) => {
  if (numberOfColumns > 1) {
    return `calc(${100 / numberOfColumns}% - ${grid.lg} - ${
      numberOfColumns > 2 ? numberOfColumns - 2 : 0
    }*${grid.md}) repeat(${numberOfColumns - 1}, 1fr)`;
  }
  return '1fr';
};

export const Container = styled.div``;

export const Header = styled.header<GridProps>`
  display: grid;
  grid-template-columns: ${({ numberOfColumns }) =>
    numberOfColumns > 1 ? `${numberOfColumns - 1}fr 1fr` : '1fr 1fr'};
  column-gap: ${grid.md};
  border-bottom: 1px solid #e6e6e6;
`;

export const HeaderTitle = styled.span`
  margin-left: ${grid.xs};
  font-weight: 600;
  font-size: 114.28%;
`;

export const SearchForm = styled.form``;

export const Wrapper = styled.div`
  display: flex;
  column-gap: ${grid.xs};
  align-items: center;
  border-bottom: 2px solid #b2b2b2;
  padding-bottom: ${grid.xs};
`;

export const WrapperInput = styled.input`
  border: none;
`;

export const Content = styled.div<GridProps>`
  margin-top: ${grid.md};
  display: grid;
  column-gap: ${grid.md};
  row-gap: ${grid.xl};
  margin-left: ${grid.xl};
  grid-template-columns: ${({ numberOfColumns }) =>
    calculateColumns(numberOfColumns)};
`;
